/* VIVID upload-box behaviors (pairs with nt-vivid-upload.css), 2026-06-11.
   r7: drag-over paints an overlay DIV on the visual zone; invalid files are
   intercepted at document-capture BEFORE the engines run (validation
   mirrors the engines' own imagesTypes lists); main-box errors persist
   until the user restores IN PLACE (no reload); the multi modal's
   add-another error auto-restores after ~2.6s so in-modal progress is
   never lost. */
(function () {
  'use strict';
  if (window.__ntVividDragInit) return;
  window.__ntVividDragInit = true;

  /* [data-gserr-drop] = the gang-sheet error card's dropstrip (Owen 9-25):
     while the card replaces the (hidden) upload box, the strip is the page's
     drop target, so the full-screen "Drop your file / anywhere to upload"
     overlay + stray-drop forwarding work in the error state too. Its own
     handlers in pdp_transferBySize.js run the upload; interceptFiles never
     swallows on gang pages (the .uploadError guard below). */
  var SELECTOR = '.upload-area__drop-zoon.drop-zoon, .uploadBox__layout, .secondDropZone, [data-pcv2-dropzone], [data-gserr-drop]';
  var ZONE = '.dtfut__panel, master-upload, .upload-area, .uploadBox, another-upload, another-upload-multi';
  function boxFor(target) {
    if (!target || !target.closest) return null;
    var direct = target.closest(SELECTOR);
    if (direct) return direct;
    var zone = target.closest(ZONE);
    return zone ? zone.querySelector(SELECTOR) : null;
  }

  /* ---- drag-over state: FULL-SCREEN overlay (Justin 2026-06-12 v2 —
     the upload boxes stay untouched; a file drag anywhere in the window
     raises a dark overlay: blue-circle cloud glyph + "Drop your file(s) /
     anywhere to upload", plural when the product's upload takes multiple
     files). Clears on window-leave, drop, or cancel; drops anywhere are
     forwarded to the box by the drop handler below. ---- */
  function isFileDrag(e) {
    var dt = e.dataTransfer;
    if (!dt || !dt.types) return false;
    for (var i = 0; i < dt.types.length; i++) if (dt.types[i] === 'Files') return true;
    return false;
  }
  function isMultiUpload() {
    var box = dropTarget();
    if (!box) return false;
    if (box.classList.contains('secondDropZone')) return true; /* modal always takes more */
    var zone = box.closest(ZONE) || box;
    var inp = zone.querySelector('input[type=file]');
    return !!(inp && inp.multiple);
  }
  var dragActive = false;
  /* Post-first-upload scope (Justin 2026-07-08): once a design is uploaded on a
     SINGLE-upload product, the "drag anywhere" full-screen invite is wrong — a
     stray drop would push the customer's design into the add-another flow. From
     that point the overlay shows ONLY while hovering the add-another box, and
     stray drops are swallowed. True multi-upload products (vivid v3: the
     multi-upload / uploaded-files-block elements) keep the June drag-anywhere
     behavior, as does the pre-first-upload state everywhere. */
  function scopedToBox() {
    /* Not while the gang-sheet error card is up (Owen 9-25): its failed
       upload set image-uploaded, but there is no committed design to
       protect — the card's whole point is "give us a new file", so the
       drag-anywhere overlay + stray-drop forwarding must work. */
    if (document.querySelector('.uploadError:not(.hidden)')) return false;
    return document.body.classList.contains('image-uploaded') &&
      !document.querySelector('multi-upload, uploaded-files-block');
  }
  function overSecondBox(target) {
    return !!(target && target.closest && target.closest('another-upload, another-upload-multi, .secondDropZone'));
  }
  function showDropScreen() {
    if (document.querySelector('.nt-drop-screen')) return;
    var el = document.createElement('div');
    el.className = 'nt-drop-screen';
    el.innerHTML = '<div class="nt-drop-screen__inner">' +
      '<div class="nt-drop-screen__glyph w3_bg" aria-hidden="true"></div>' +
      '<div class="nt-drop-screen__title">' + (isMultiUpload() ? 'Drop your file(s)' : 'Drop your file') + '</div>' +
      '<div class="nt-drop-screen__sub">anywhere to upload</div>' +
      '</div>';
    document.body.appendChild(el);
  }
  function clearAll() {
    var sc = document.querySelector('.nt-drop-screen');
    if (sc) sc.remove();
    dragActive = false;
  }
  document.addEventListener('dragover', function (e) {
    if (!isFileDrag(e)) return;
    if (!dragActive && !dropTarget()) return; /* no usable upload box on this page */
    /* allow drop events everywhere so the release can be forwarded to the
       box instead of the browser navigating to the file (and, in scoped mode,
       so the swallow in the drop handler fires instead of a navigation) */
    e.preventDefault();
    if (scopedToBox()) {
      if (overSecondBox(e.target)) {
        dragActive = true;
        showDropScreen();
      } else if (document.querySelector('.nt-drop-screen')) {
        clearAll();
      }
      return;
    }
    if (!dragActive) {
      dragActive = true;
      showDropScreen();
    }
  }, true);
  document.addEventListener('dragleave', function (e) {
    if (!e.relatedTarget) clearAll(); /* left the window */
  }, true);
  document.addEventListener('dragend', clearAll, true);

  /* ---- error-message attr mirroring: CSS attr() reads the pseudo's OWN
     element, so the per-product strings on <master-upload> must be copied
     onto the paragraph that hosts the detail line ---- */
  function mirrorErrMsgs() {
    var any = false;
    document.querySelectorAll('master-upload[err-type-msg], master-upload[err-size-msg]').forEach(function (mu) {
      var dz = mu.querySelector(SELECTOR);
      if (!dz) return;
      any = true;
      var para = dz.querySelector('.drop-zoon__paragraph') || dz;
      ['err-type-msg', 'err-size-msg'].forEach(function (a) {
        var v = mu.getAttribute(a);
        if (!v) return;
        if (dz.getAttribute(a) !== v) dz.setAttribute(a, v);
        if (para.getAttribute(a) !== v) para.setAttribute(a, v);
      });
    });
    return any;
  }
  var tries = 0;
  (function tick() {
    if (mirrorErrMsgs() || ++tries > 40) return;
    setTimeout(tick, 500);
  })();

  /* ---- validation: mirror the ENGINES' own type lists exactly, so a
     file we pass is never one the engine red-squares. Lists live as
     imagesTypes (old engine, window-reachable var) / imagesTypesNew (new
     engine + blanks, top-level const — parse it out of the inline
     script). Fallback: the contextual input's accept attr. Engines match
     by fileType.indexOf(fragment). ---- */
  var cachedTypes;
  function engineTypes() {
    if (cachedTypes !== undefined) return cachedTypes;
    var list = null;
    if (window.imagesTypesNew && window.imagesTypesNew.length) list = window.imagesTypesNew;
    else if (window.imagesTypes && window.imagesTypes.length) list = window.imagesTypes;
    if (!list) {
      var scripts = document.querySelectorAll('script:not([src])');
      for (var i = 0; i < scripts.length; i++) {
        var m = scripts[i].textContent.match(/imagesTypes(?:New)?\s*=\s*(\[[^\]]*\])/);
        if (m) {
          try { list = JSON.parse(m[1].replace(/'/g, '"')); } catch (err) { list = null; }
          if (list && list.length) break;
        }
      }
    }
    cachedTypes = (list && list.length) ? list : null;
    return cachedTypes;
  }
  function acceptTypes(ctx) {
    var inp = null;
    if (ctx && ctx.matches && ctx.matches('input[type=file]') && ctx.getAttribute('accept')) inp = ctx;
    if (!inp && ctx && ctx.closest) {
      var zone = ctx.closest('another-upload, another-upload-multi, .uploadBox, master-upload, .upload-area, .dtfut__panel');
      if (zone) inp = zone.querySelector('input[type=file][accept]');
    }
    if (!inp) inp = document.querySelector('input[type=file][accept]');
    return inp ? inp.getAttribute('accept').split(',').map(function (x) { return x.trim(); }) : null;
  }
  function fileOk(f, ctx) {
    if (f.size > 5368709120) return false; /* engines' 5GB cap */
    var types = engineTypes() || acceptTypes(ctx);
    if (!types || !types.length) return true; /* nothing to validate against */
    var ft = (f.type || '').toLowerCase();
    for (var i = 0; i < types.length; i++) {
      var t = String(types[i]).toLowerCase();
      if (t.charAt(0) === '.') t = t.slice(1); /* accept-attr ext entries */
      if (t && ft.indexOf(t) !== -1) return true;
    }
    return false;
  }
  function anyInvalid(files, ctx) {
    if (!files || !files.length) return false;
    for (var i = 0; i < files.length; i++) if (!fileOk(files[i], ctx)) return true;
    return false;
  }

  /* ---- injected error card (blanks page box + modal add-another) ---- */
  function cardHTML() {
    return '<div class="nt-upload-error">' +
      '<div class="nt-upload-error__circle" aria-hidden="true"></div>' +
      '<div class="nt-upload-error__head">Couldn\'t upload your files</div>' +
      '<div class="nt-upload-error__msg">Uploaded file type not supported, Please upload a valid file type.</div>' +
      '<button type="button" class="nt-upload-error__btn">Upload a New Image</button></div>';
  }
  function showCard(host, autoRestoreMs) {
    if (!host || host.querySelector(':scope > .nt-upload-error')) return;
    host.classList.add('nt-error-host');
    var wrap = document.createElement('div');
    wrap.innerHTML = cardHTML();
    host.appendChild(wrap.firstChild);
    if (autoRestoreMs) setTimeout(function () { clearCard(host); }, autoRestoreMs);
  }
  function clearCard(host) {
    if (!host) return;
    host.classList.remove('nt-error-host');
    var c = host.querySelector(':scope > .nt-upload-error');
    if (c) c.remove();
  }

  /* ---- persistence lock: engines add the error class then auto-remove
     it ~2-3.5s later (and other handlers keep uploading). Removals are
     ILLEGITIMATE by default — only our own restore / a fresh valid file
     opens a clearance window. Any error ADD slams the window shut. ---- */
  var allowClearUntil = 0;
  function permitClear(ms) { allowClearUntil = Date.now() + (ms || 3000); }
  function restoreMaster(mu) {
    permitClear(3000);
    mu.classList.remove('drop-disabled-type');
    mu.classList.remove('drop-disabled-size');
  }
  new MutationObserver(function (muts) {
    muts.forEach(function (m) {
      var el = m.target;
      if (!el.matches || !el.matches('master-upload')) return;
      var hadT = (m.oldValue || '').indexOf('drop-disabled-type') > -1;
      var hadS = (m.oldValue || '').indexOf('drop-disabled-size') > -1;
      var hasT = el.classList.contains('drop-disabled-type');
      var hasS = el.classList.contains('drop-disabled-size');
      if ((hasT && !hadT) || (hasS && !hadS)) { allowClearUntil = 0; return; }
      if ((hadT && !hasT) || (hadS && !hasS)) {
        if (Date.now() > allowClearUntil) {
          if (hadT) el.classList.add('drop-disabled-type');
          if (hadS) el.classList.add('drop-disabled-size');
        }
      }
    });
  }).observe(document.documentElement, { attributes: true, attributeFilter: ['class'], attributeOldValue: true, subtree: true });

  /* ---- CAPTURE-phase interception: validate BEFORE any engine handler.
     Invalid → context-appropriate error, engines never see the event (so
     the multi modal never opens on a mixed bad drop, and nothing uploads
     a rejected file). The dtf modal's box is <another-upload> with its
     file input as a FOLLOWING SIBLING — closest() can't reach it from the
     input. ---- */
  function modalBoxFor(t) {
    var a = t.closest && t.closest('another-upload, another-upload-multi');
    if (!a && t.matches && t.matches('input[type=file]')) {
      var prev = t.previousElementSibling;
      if (prev && /^ANOTHER-UPLOAD/.test(prev.tagName)) a = prev;
      else if (/^anotherFile/.test(t.id || '')) a = document.querySelector('another-upload, another-upload-multi');
    }
    return a;
  }
  function interceptFiles(e, files) {
    var t = e.target;
    if (!anyInvalid(files, t)) return false;
    var another = modalBoxFor(t);
    if (another) {
      /* modal: auto-restore so in-modal progress isn't lost (Justin r7) */
      showCard(another.querySelector('.secondDropZone') || another, 2600);
      return true;
    }
    var blanksBox = t.closest && t.closest('.uploadBox');
    if (blanksBox) {
      showCard(blanksBox.querySelector('.uploadBox__layout') || blanksBox, 0);
      return true;
    }
    var mu = t.closest && t.closest('master-upload');
    if (!mu) {
      var z2 = t.closest && t.closest('.upload-area, .dtfut__panel');
      if (z2) mu = z2.querySelector('master-upload') || (z2.closest && z2.closest('master-upload'));
    }
    if (mu) {
      /* gang sheets have a dedicated width-first error flow (.uploadError,
         "must be 22 inches wide") — the engine must receive every file so
         it can measure width; its own type errors still land on the
         drop-disabled classes (Justin r8: width has priority over type) */
      if (document.querySelector('.uploadError')) return false;
      allowClearUntil = 0;
      mu.classList.add('drop-disabled-type');
      return true;
    }
    return false;
  }
  function onValidFiles(t) {
    /* fresh legit upload: open the clearance window past the engines'
       joint 3.5s cleanup, and clear any prior error so the flow restarts
       clean */
    permitClear(4000);
    var zone = t.closest && t.closest('.upload-area, .dtfut__panel');
    var mu = (t.closest && t.closest('master-upload')) || (zone && zone.querySelector('master-upload'));
    if (mu && (mu.classList.contains('drop-disabled-type') || mu.classList.contains('drop-disabled-size'))) restoreMaster(mu);
  }
  /* Stray drops are FORWARDED to the active upload box (Justin
     2026-06-12: arming the whole window means the release must count
     anywhere, not just inside the box). The open modal's add-another box
     wins over the page box behind it. */
  function dropTarget() {
    var boxes = Array.prototype.filter.call(document.querySelectorAll(SELECTOR), function (b) {
      return b.offsetWidth > 0 && !b.classList.contains('nt-error-host') && !b.closest('.nt-error-host');
    });
    if (!boxes.length) return null;
    /* the price calculator's dropzone wins while its popup is open (its
       native drop handler feeds #fileInput AND closes the popup) */
    for (var i = 0; i < boxes.length; i++) {
      if (boxes[i].hasAttribute && boxes[i].hasAttribute('data-pcv2-dropzone')) return boxes[i];
    }
    for (var j = 0; j < boxes.length; j++) {
      if (boxes[j].classList.contains('secondDropZone')) return boxes[j];
    }
    return boxes[0];
  }
  var forwarding = false;
  /* add-another boxes: deliver files through the box's FILE INPUT — the
     native Browse path, which every engine wires to "commit the current
     design to cart, refresh, then continue with the new file(s)". The
     engines' own DROP handlers skip that commit step (multi-file drops
     opened the modal without carting the first design — Justin
     2026-06-12), so both stray AND direct drops route through here. */
  function forwardViaInput(box, dataTransfer) {
    var holder = box.closest('another-upload, another-upload-multi');
    var inp = holder && holder.nextElementSibling && holder.nextElementSibling.matches && holder.nextElementSibling.matches('input[type=file]') ? holder.nextElementSibling : null;
    if (!inp) inp = document.getElementById('anotherFileMultiple') || document.getElementById('anotherFile');
    if (!inp) return false;
    try {
      inp.files = dataTransfer.files;
      inp.dispatchEvent(new Event('change', { bubbles: true }));
      return true;
    } catch (err) {
      return false;
    }
  }
  document.addEventListener('drop', function (e) {
    var files = e.dataTransfer && e.dataTransfer.files;
    if (interceptFiles(e, files)) {
      e.preventDefault();
      e.stopImmediatePropagation();
    } else if (files && files.length) {
      /* Scoped mode: a release anywhere but ON the add-another box does
         nothing (no forward, no navigation). */
      if (scopedToBox() && !overSecondBox(e.target)) {
        e.preventDefault();
        e.stopImmediatePropagation();
        clearAll();
        return;
      }
      var box = boxFor(e.target);
      if (box || forwarding) {
        if (!forwarding && box && box.classList.contains('secondDropZone') && !box.closest('multi-upload-wrapper, multi-upload')) {
          /* direct drop on the page-level add-another box → Browse path
             (the modal's own box keeps its native drop handling) */
          e.preventDefault();
          e.stopImmediatePropagation();
          forwarding = true;
          try { forwardViaInput(box, e.dataTransfer); } finally { forwarding = false; }
        } else {
          onValidFiles(e.target);
        }
      } else {
        /* released outside every box: cancel the browser's default (it
           would navigate to the file) and re-deliver on the active box */
        e.preventDefault();
        e.stopImmediatePropagation();
        var target = dropTarget();
        if (target) {
          forwarding = true;
          try {
            var handled = false;
            if (target.classList.contains('secondDropZone')) {
              handled = forwardViaInput(target, e.dataTransfer);
            }
            if (!handled) {
              target.dispatchEvent(new DragEvent('drop', { bubbles: true, cancelable: true, dataTransfer: e.dataTransfer }));
            }
          } finally {
            forwarding = false;
          }
        }
      }
    }
    clearAll();
  }, true);
  document.addEventListener('change', function (e) {
    if (!e.target || !e.target.matches || !e.target.matches('input[type=file]')) return;
    if (interceptFiles(e, e.target.files)) {
      e.preventDefault();
      e.stopImmediatePropagation();
      e.target.value = '';
    } else if (e.target.files && e.target.files.length) {
      onValidFiles(e.target);
    }
  }, true);

  /* ---- clicks in error states (capture: the engines' click-to-browse
     must not fire). "Upload a New Image" restores the box IN PLACE —
     no reloads anywhere (Justin r7). ---- */
  document.addEventListener('click', function (e) {
    var t = e.target;
    var modalHost = t.closest && t.closest('.secondDropZone.nt-error-host');
    if (modalHost) {
      e.preventDefault();
      e.stopPropagation();
      if (t.closest('.nt-upload-error__btn')) clearCard(modalHost);
      return;
    }
    var blanksHost = t.closest && t.closest('.uploadBox__layout.nt-error-host');
    if (blanksHost) {
      e.preventDefault();
      e.stopPropagation();
      if (t.closest('.nt-upload-error__btn')) clearCard(blanksHost);
      return;
    }
    var muErr = t.closest && t.closest('master-upload.drop-disabled-type, master-upload.drop-disabled-size');
    if (muErr) {
      e.preventDefault();
      e.stopPropagation();
      if (t.closest('button')) restoreMaster(muErr);
      return;
    }
    /* legacy modal error TILE (engine-built paths) */
    var tile = t.closest && t.closest('uploaded-files-block.drop-disabled-type');
    if (tile && t.closest('.nt-upload-error__btn')) {
      e.preventDefault();
      e.stopPropagation();
      var blocks = document.querySelectorAll('multi-upload uploaded-files-block');
      var del = tile.querySelector('item-no .itemNo__action a');
      if (blocks.length > 1 && del) {
        tile.querySelectorAll(':scope > *').forEach(function (c) { c.style.removeProperty('display'); });
        del.click();
      } else {
        tile.classList.remove('drop-disabled-type');
        var card = tile.querySelector('.nt-upload-error');
        if (card) card.remove();
      }
    }
  }, true);

  /* ---- Ordering Options modal: opened by assets/nt-oo-modal.js (window.NTOO),
     which owns the [data-nt-oo-file] delegated click since the 2026-09-10
     redesign — nothing to do here. ---- */

  /* legacy tile dressing (fallback only) */
  function dressErrorTiles() {
    document.querySelectorAll('multi-upload uploaded-files-block.drop-disabled-type').forEach(function (tile) {
      if (tile.querySelector('.nt-upload-error')) return;
      var wrap = document.createElement('div');
      wrap.innerHTML = cardHTML();
      tile.appendChild(wrap.firstChild);
    });
  }
  new MutationObserver(dressErrorTiles)
    .observe(document.documentElement, { attributes: true, attributeFilter: ['class'], subtree: true });
})();
